<template>
	<div class="modal" :class="{'is-active' : isActive}">
		<div class="modal-background"></div>
		<form action="" @submit.prevent="guardarQuiniela" style="display: contents;">
			<div class="modal-card quiniela-form is-relative">
					<header class="modal-card-head">
						<p class="modal-card-title">{{ (info) ? ((!quiniela.privada) ? 'Unete a la quiniela':'Unete a esta quiniela privada'):'Haz tu quiniela'}}</p>
						<button class="delete" @click.prevent="closeModal()" aria-label="close"></button>
					</header>
					<section class="modal-card-body">
						<div class="content">
							<article v-if="quiniela.apuesta > user.user.puntos" class="message is-warning is-fixed">
								<div class="message-body">
									No cuentas con los puntos suficientes para hacer esta quiniela
								</div>
							</article>
							<article v-if="quiniela.privada && info" class="message is-info">
								<div class="message-body">
									El creador de esta quiniela recibira tu solicitud para unirte
								</div>
							</article>
							<div v-if="!info">
								<div class="columns">
									<div class="column">
										<div class="field">
											<label for="" class="label">Contra quien quieres jugar?</label>
											<label class="radio is-block">
												<input type="radio" name="tipo" value="0" v-model="quiniela.tipo">
												<span class="icon"><font-awesome-icon icon="file" /></span> Quinielazo (Parlay)
												<p class="help">Juegas contra quinielazo<br><span class="has-text-grey-light">Debes acertar todos los resultados para ganar</span></p>
											</label>
											<label class="radio">
												<input type="radio" name="tipo" value="1" v-model="quiniela.tipo">
												<span class="icon"><font-awesome-icon icon="users" /></span> Amigos
												<p class="help">Invita y compite con tus amigos<br><span class="has-text-grey-light">Gana el que tenga mas aciertos al final de los partidos</span></p>
											</label>
										</div>
									</div>
									<div class="column">
										<div class="field">
											<label for="" class="label">Nombre Quiniela</label>
											<div class="control">
												<input type="text" class="input is-small" v-model="quiniela.nombre" @input="e => quiniela.nombre = e.target.value.replace(/[^a-zA-Z0-9.-]/g,'')" placeholder="Nombre de tu quiniela.." maxlength="15">
												<p class="help">Puedes dejar este campo en blanco..</p>
											</div>
										</div>
										<div class="field">
											<div class="control">
												<label for="privada" class="checkbox">
													<input id="privada" name="privada" type="checkbox" value="1" v-model="quiniela.privada"> <span class="icon"><font-awesome-icon icon="lock" /></span> Privada?
													<p class="help">Solo tú y los jugadores de la quiniela podran ver el contenido de ella</p>
												</label>
											</div>
										</div>
									</div>
									<div class="column">
										<div class="field">
											<label for="" class="label"><span class="icon"><font-awesome-icon icon="coins"/></span> Apuesta ({{Number(user.user.puntos).toLocaleString() }} pts)</label>
											<input type="number" class="input is-small" placeholder="Cuanto apuestas?" v-model="quiniela.apuesta">
											<p class="help">Mínimo 100 puntos</p>
										</div>
									</div>
								</div>
								<hr>
							</div>
							
							<div v-if="info">
								<div class="columns">
									<div class="column">
										<div class="field has-text-centered">
											<label for="" class="label">Nombre Quiniela</label>
											<div class="control has-text-centered">
												<font-awesome-icon v-if="info && info.privada" icon="lock" /> {{ info.nombre }}
											</div>
										</div>
									</div>
									<div class="column">
										<div class="field has-text-centered">
											<label for="" class="label"><span class="icon"><font-awesome-icon icon="coins"/></span> Apuesta</label>
											{{ info.apuesta }}
										</div>
									</div>
									<div class="column">
										<div class="field has-text-centered">
											<label for="" class="label">
												<span class="icon"><font-awesome-icon icon="users" /></span>
												Integrantes
											</label>
											{{ info.jugadores != undefined ? info.jugadores.length:'' }}
										</div>
									</div>
								</div>
								<hr>
							</div>

							<div class="columns">

								<!-- Partidos -->
								<div class="column">
									<p class="subtitle"><span class="icon"><font-awesome-icon icon="futbol"/></span> Partidos</p>

									<div class="columns is-mobile predicciones is-multiline" v-for="(partido,key) in partidos" :key="partido.id">
										<div class="column truncate is-4">
											{{ partido.equipo_local.nombre }}
										</div>
										<div class="column has-text-centered is-flex centrado is-4">
											<label class="container-radio">
												<input type="radio" :name="'partidos[' + partido.id + ']'" :value="{partido: partido.id, resultado:'L', momio: partido.momios_local}" v-model="quiniela.predicciones[key]">
												<span class="checkmark">L</span>
											</label>
											<label class="container-radio">
												<input type="radio" :name="'partidos[' + partido.id + ']'" :value="{partido: partido.id, resultado:'E', momio: partido.momios_empate}" v-model="quiniela.predicciones[key]">
												<span class="checkmark">E</span>
											</label>
											<label class="container-radio">
												<input type="radio" :name="'partidos[' + partido.id + ']'" :value="{partido: partido.id, resultado:'V', momio: partido.momios_visitante}" v-model="quiniela.predicciones[key]">
												<span class="checkmark">V</span>
											</label>
										</div>
										<div class="column has-text-right truncate is-4">
											{{ partido.equipo_visitante.nombre }}
										</div>

										<div v-if="quiniela.tipo == 0" class="column momios has-text-left is-4"><p>{{partido.momios_local}}</p></div>
										<div v-if="quiniela.tipo == 0" class="column momios has-text-centered is-4"><p>{{partido.momios_empate}}</p></div>
										<div v-if="quiniela.tipo == 0" class="column momios has-text-right is-4"><p>{{partido.momios_visitante}}</p></div>
									</div>
									
								</div>
								<!-- /Partidos -->

								<div class="column is-5" v-if="quiniela.tipo == 0">
									<p class="subtitle"><span class="icon"><font-awesome-icon icon="coins"/></span> Premio</p>
									<p class="title">{{ sumaMomios }} pts</p>
								</div>
							</div>
						</div>
					</section>
					<footer class="modal-card-foot">
						<button class="button is-info" :disabled="!canSubmit">Guardar</button>
						<button class="button" @click.prevent="closeModal()">Cancelar</button>
					</footer>
			</div>
		</form>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {

		name: 'HacerQuinielaModal',
		props: {
			active: {
				type: Boolean,
				default: false
			},
			partidos: {
				type: Array,
				default: function(){
					return []
				}
			},
			info: {
				type: Object,
				required: false
			}
		},
		data() {
			return {
				quiniela:{
					tipo: null,
					nombre: null,
					apuesta: null,
					privada: 0,
					predicciones: []
				}
			};
		},
		mounted(){
			if (this.info) {
				this.quiniela.id = this.info.id
				this.quiniela.tipo = this.info.tipo
				this.quiniela.nombre = this.info.nombre
				this.quiniela.apuesta = this.info.apuesta
				this.quiniela.privada = this.info.privada
			}
		},
		computed: {
			isActive(){
				return this.active;
			},
			canSubmit(){
				if (this.quiniela.tipo != null && this.quiniela.apuesta >= 100  
					&& this.quiniela.predicciones.filter(Boolean).length == this.partidos.length 
					&& this.quiniela.apuesta <= this.user.user.puntos
				) {

						return true
				}else{
					return false
				}
			},
			sumaMomios(){
				let momios = 0
				for(let prediccion in this.quiniela.predicciones){
					momios = momios + parseFloat(this.quiniela.predicciones[prediccion].momio)
				}

				return Number(Math.ceil(parseFloat(this.quiniela.apuesta * momios))).toLocaleString()
			},
			...mapState('user',['user'])
		},
		methods:{
			closeModal(){
				this.$emit('close')
			},
			clearQuiniela(){
				this.quiniela = {
					id: null,
					tipo: null,
					nombre: null,
					apuesta:null,
					privada: 0,
					predicciones: []
				}
			},
			guardarQuiniela(){
				this.$store.dispatch('quinielas/saveQuiniela',this.quiniela)
				.then(resp => {
					this.clearQuiniela()
					this.closeModal()
					//Si no esta en la pagina
					if (this.$route.fullPath != '/ver-quiniela/' + resp.data.id) {
						//redireccionarlo
						this.$router.push({name: 'ver-quiniela', params: {id: resp.data.id }})
					}
				})
			}
		}
	};
</script>

<style lang="css" scoped>
.centrado{
	justify-content: center;
}
.radio{
	margin-bottom: 1em;
	margin-left: 0 !important;
}
@media screen and (min-width: 769px), print{
	.quiniela-form{
		width: 800px;
	}
} 
.quiniela-form{
	margin: 0;
}
.is-fixed{
	position: absolute;
	z-index: 40;
	width: 90%;
	left: 5%;
	bottom: 70px;
	-webkit-box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.65);
    -moz-box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.65);
    box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.65);
}
.momios{
	padding: 0 .75rem;
	font-size: .7em;
}
.predicciones > div{
	padding-bottom: .3em;
}
</style>
